import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const CartFilledIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="24.519"
    height="22.497"
    viewBox="0 0 24.519 22.497"
    fill={"none"}
    strokeWidth={0.5}
    {...props}
  >
    <g transform="translate(-1365.741 -1480.501)">
      <path
        d="M1673.981-7357.367c-2.8,0-7.785,0-11.5,0,0-.054,0-.108,0-.162a4.771,4.771,0,0,1,5-4.5,5.563,5.563,0,0,1,1.613.238,6.728,6.728,0,0,1,5.389-2.237,6.9,6.9,0,0,1,5.241,2.051,5.709,5.709,0,0,1,.758-.052,4.77,4.77,0,0,1,5,4.5c0,.054,0,.108,0,.162h-5.5C1677.7-7357.364,1675.513-7357.364,1673.981-7357.367Z"
        transform="translate(-295.981 8844.528)"
      />
      <g transform="translate(1366 1487.967)">
        <g transform="translate(0 0.034)">
          <path
            d="M14.465,13.864H11.449l-6.324,0a2.568,2.568,0,0,1-1.95-.9,3.316,3.316,0,0,1-.789-2.08,4.748,4.748,0,0,0-.079-.617c-.023-.133-.041-.241-.056-.34q-.189-1.305-.38-2.61l-.048-.332q-.1-.672-.2-1.345Q1.5,4.77,1.373,3.907l-.119-.815-.119-.815c-.028-.2-.057-.652-.086-1.092S.993.292.965.095C1,.058,7.6.033,13.495.033c5.858,0,9.513.022,9.537.059-.006.012-.014.125-.026.3-.039.544-.119,1.672-.16,1.963l-.122.84-.033.224q-.128.882-.257,1.764l-.063.43-.063.43q-.084.563-.166,1.126-.07.481-.139.962l-.146,1.012q-.047.324-.1.648c-.043.283-.1.655-.148,1.012-.009.063-.014.133-.02.207l0,.021v.012a3.092,3.092,0,0,1-.1.633A2.809,2.809,0,0,1,19.386,13.8a2.935,2.935,0,0,1-.651.06ZM2.454.146l.374,3.577,0,.031c.027.181.163,1.112.234,1.6q.059.4.118.809v.006l.118.8c.121.827.249,1.714.376,2.6.015.1.033.214.057.351a7.206,7.206,0,0,1,.117.951A1.324,1.324,0,0,0,5.095,12.2c1.935,0,4.013-.006,6.737-.006H18.9a1.19,1.19,0,0,0,.239-.018,1.317,1.317,0,0,0,.994-1.2c.035-.392.091-.775.146-1.145l.006-.044c.032-.21.057-.381.078-.538.049-.368.1-.738.157-1.1l.016-.11q.046-.3.09-.608.031-.216.062-.432l0-.029q.029-.2.059-.407l.02-.139q.07-.483.14-.967.054-.374.11-.749l.055-.374.074-.5.074-.5c.1-.681.3-3.061.3-3.085L2.454.146h0Z"
            transform="translate(0.07 0.884)"
          />
          <path
            d="M23.807.255A.525.525,0,0,0,23.38,0H.62A.525.525,0,0,0,.193.255a1.31,1.31,0,0,0-.148,1.04c.092.358.306.582.568.582q1.531,0,3.063,0H20.324q1.531,0,3.063,0c.262,0,.476-.224.568-.582a1.31,1.31,0,0,0-.148-1.04"
            transform="translate(0 -0.837)"
          />
          <path
            d="M1.591.237A1.028,1.028,0,0,0,.605.052.82.82,0,0,0,0,.836C0,1.557,0,2.289,0,3v.716q0,.406,0,.811C0,5.2,0,5.908,0,6.6a.878.878,0,0,0,.927.834h0a.978.978,0,0,0,.738-.313.792.792,0,0,0,.2-.524c0-1.949,0-3.911,0-5.754A.8.8,0,0,0,1.591.237"
            transform="translate(11.134 3.584)"
          />
          <path
            d="M2.714,5.994q-.171-1-.344-2L2.145,2.687,1.8.681A.9.9,0,0,0,.807,0a.873.873,0,0,0-.7.353.674.674,0,0,0-.1.508c.022.111.039.222.058.339.011.068.021.135.033.2l.014.083c.081.477.165.97.249,1.455q.067.388.136.775.06.342.12.684.056.321.111.642c.066.381.133.775.2,1.163a.878.878,0,0,0,.927.625h.008a.8.8,0,0,0,.85-.67l0-.02V6.118a.722.722,0,0,0-.009-.124"
            transform="translate(6.087 3.969)"
          />
          <path
            d="M2.614.356A.873.873,0,0,0,1.917,0,.9.9,0,0,0,.926.681L.579,2.687.353,4q-.172,1-.344,2A.72.72,0,0,0,0,6.118v.025l0,.02a.8.8,0,0,0,.85.67H.86a.878.878,0,0,0,.927-.625c.069-.388.137-.782.2-1.163q.055-.321.111-.642.06-.343.12-.685.068-.387.136-.774c.084-.485.168-.978.249-1.455l.014-.083c.012-.067.022-.135.033-.2.018-.118.036-.228.058-.34a.674.674,0,0,0-.1-.508"
            transform="translate(15.098 3.969)"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);
